import React, { useEffect, useState } from 'react';
import {
    Box,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
} from '@mui/material';
import { MasterMessage } from '../../../../masters/masterMessages';
import { Modal } from 'react-responsive-modal';
import ButtonGeneral from '../../../components/general/buttons/buttonGeneral';
import Save from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FieldText from '../../../components/general/fields/fieldText';
import {
    asyncPatchAnswer,
    asyncPostAnswer,
} from '../../../../services/survey.service';
import { SwalCustomClass } from '../../../components/general/toastSwal/swalCustomClass';
import Loading from '../../../components/general/loading/loading';

type Props = {
    open: boolean;
    onClose: (value: boolean) => void;
    saveLoad: (value: boolean) => void;
    idSurvey?: string;
    idQuestion?: string;
    idAnswer?: string;
    answer?: any | undefined;
    loading: false | boolean;
};

const ModalRange = ({
    open,
    onClose,
    saveLoad,
    idSurvey,
    idQuestion,
    idAnswer,
    answer,
    loading,
}: Props) => {
    const { range }: any = MasterMessage.surveys;
    const [otherRange, setOtherRange] = useState<boolean>(false);

    const formik = useFormik({
        initialValues: {
            range: '1-5',
            range1: '',
            range2: '',
            status: true,
            question: idQuestion,
            survey: idSurvey,
        },
        validationSchema: Yup.object({
            range1: Yup.number().when({
                is: () => otherRange,
                then: (schema) =>
                    schema
                        .required('El rango es obligatorio')
                        .typeError('El rango debe ser un número'),
            }),
            range2: Yup.number().when({
                is: () => otherRange,
                then: (schema) =>
                    schema
                        .required('El rango es obligatorio')
                        .typeError('El rango debe ser un número'),
            }),
        }),
        onSubmit: async (formModalRange) => {
            formModalRange.range = otherRange
                ? `${formModalRange.range1}-${formModalRange.range2}`
                : formModalRange.range;
            if (idAnswer) {
                asyncPatchAnswer(idAnswer, formModalRange)
                    .then((body: any) => {
                        if (body?.items !== undefined) {
                            SwalCustomClass.fire({
                                text: range.messageEdit,
                                icon: 'success',
                                iconColor: '#1d1d1d',
                            });
                        } else if (body?.errors !== undefined) {
                            SwalCustomClass.fire({
                                text: range[body.message],
                                icon: 'error',
                                iconColor: '#1d1d1d',
                            });
                        }
                    })
                    .finally(() => saveLoad(true));
            } else {
                const body: any = await asyncPostAnswer(formModalRange).finally(
                    () => saveLoad(true)
                );
                if (body?.items !== undefined) {
                    SwalCustomClass.fire({
                        text: range.messageNew,
                        icon: 'success',
                        iconColor: '#1d1d1d',
                    });
                } else if (body?.errors !== undefined) {
                    SwalCustomClass.fire({
                        text: range[body.message],
                        icon: 'error',
                        iconColor: '#1d1d1d',
                    });
                }
            }
            onClose(false);
            formik.handleReset;
        },
    });

    useEffect(() => {
        if (idQuestion && answer) {
            if (
                (answer?.range && answer?.range === '1-5') ||
                answer?.range === '1-8' ||
                answer?.range === '1-10' ||
                answer?.range === '1-12'
            ) {
                formik.values.range = answer?.range;
            } else {
                formik.values.range1 = answer?.range.slice(0, 1);
                formik.values.range2 = answer?.range.slice(2, 5);
                formik.values.range = 'other';
                setOtherRange(true);
            }
            formik.values.status = answer?.status;
        }
    }, [idQuestion, answer]);

    const validateRange = (e: any) => {
        formik.handleChange(e);
        setOtherRange(e.target.value === 'other');
    };

    return (
        <Modal
            open={open}
            onClose={() => onClose(false)}
            closeOnOverlayClick={false}
            styles={{ modal: { maxWidth: '500px', minWidth: '40%' } }}
        >
            {loading ? (
                <Loading />
            ) : (
                <>
                    <Box>
                        <Typography
                            color="primary"
                            component="h3"
                            sx={{
                                fontSize: { lg: 27, xs: 23 },
                                mt: { xs: 1.5, sm: 1.5, md: 1.5, lg: 0 },
                            }}
                        >
                            {idAnswer ? range.titleEdit : range.titleNew}
                        </Typography>
                        <hr />
                        <Box mt={3} px={1}>
                            <Grid
                                container
                                spacing={{ xs: 1, md: 1 }}
                                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                            >
                                <Grid item xs={12} mx={1}>
                                    <FormControl>
                                        <FormLabel>Rango</FormLabel>
                                        <RadioGroup
                                            row
                                            name="range"
                                            value={formik.values.range}
                                            onChange={validateRange}
                                        >
                                            <FormControlLabel
                                                value="1-5"
                                                control={<Radio />}
                                                label="1-5"
                                            />
                                            <FormControlLabel
                                                value="1-8"
                                                control={<Radio />}
                                                label="1-8"
                                            />
                                            <FormControlLabel
                                                value="1-10"
                                                control={<Radio />}
                                                label="1-10"
                                            />
                                            <FormControlLabel
                                                value="1-12"
                                                control={<Radio />}
                                                label="1-12"
                                            />
                                            <FormControlLabel
                                                value="other"
                                                control={<Radio />}
                                                label="Otro"
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                    {otherRange && (
                                        <Grid container direction="row">
                                            <Grid item xs={4} mt={1}>
                                                <FieldText
                                                    label="Ej: 1"
                                                    name="range1"
                                                    size="small"
                                                    required={true}
                                                    touched={
                                                        formik.touched.range1
                                                    }
                                                    errors={
                                                        formik.errors.range1
                                                    }
                                                    value={formik.values.range1}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={4} mt={1} ml={2}>
                                                <FieldText
                                                    label="Ej: 6"
                                                    name="range2"
                                                    size="small"
                                                    required={true}
                                                    touched={
                                                        formik.touched.range2
                                                    }
                                                    errors={
                                                        formik.errors.range2
                                                    }
                                                    value={formik.values.range2}
                                                    onChange={
                                                        formik.handleChange
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    mt={1}
                                    sx={{ textAlign: 'right' }}
                                >
                                    <ButtonGeneral
                                        onClick={formik.handleSubmit}
                                        startIcon={<Save color="secondary" />}
                                        title="Guardar"
                                        sx={{ mr: 1 }}
                                    />
                                    <ButtonGeneral
                                        onClick={() => onClose(false)}
                                        startIcon={
                                            <CancelIcon color="secondary" />
                                        }
                                        title="Cerrar"
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </>
            )}
        </Modal>
    );
};

export default ModalRange;
